module.exports = __webpack_public_path__ + "media/images/mini-star-half-0800c8d97cb20496f33fa9c7596c2ff5.svg";